import { atom } from 'recoil';

const categoryId = atom({
  key: 'categoryId',
  default: '',
});

const optGroupId = atom({
  key: 'optGroupId',
  default: '',
});

const menuOrderGategoryId = atom({
  key: 'menuOrderGategoryId',
  default: { type: '', id: '', title: '' },
});

const menuScroll = atom({
  key: 'menuScroll',
  default: {
    depth1: 0,
    depth2: 0,
  },
});

export { categoryId, optGroupId, menuOrderGategoryId, menuScroll };
